import { Directive, effect, inject, input, OnDestroy, OnInit } from '@angular/core';

import { KROS_FORM_FIELD_HOST } from '../kros-form-field/kros-form-field.token';

@Directive({
  selector: '[krosInvalidIcon]',
  standalone: false,
})
export class KrosInvalidIcon implements OnInit, OnDestroy {
  hasSuffix = input(false);

  readonly #formFieldInvalidIconClass = 'kros-form-field-infix-right';
  readonly #formFieldSuffixMultipleClass = 'kros-form-field-infix-right-suffix-and-invalid';

  #formField = inject(KROS_FORM_FIELD_HOST);

  constructor() {
    effect(() => {
      if (this.hasSuffix()) {
        this.#formField.addClass(this.#formFieldSuffixMultipleClass);
      }
    });
  }

  ngOnInit(): void {
    this.#formField.addClass(this.#formFieldInvalidIconClass);
  }

  /** `kros-form-field-infix-right` is shared with the suffix, which still needs it after the icon goes away. */
  ngOnDestroy(): void {
    this.#formField.removeClass(this.#formFieldSuffixMultipleClass);
    if (!this.hasSuffix()) {
      this.#formField.removeClass(this.#formFieldInvalidIconClass);
    }
  }
}
